// App.js
import React, { useEffect, useState } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import Hero from './components/Hero';
//import Servicios from './components/Servicios';
import ServiciosElect from './components/ServiciosElect';
import ServiciosIndustria from './components/ServiciosIndustria';


import BusinessUnits from './components/BusinessUnits';

import Contact from './components/Contact';
import Footer from './components/Footer';
import LogosSlider from './components/LogoSlider';
import Nosotros from './components/Nosotros';
import Valores from './components/Valores';

import ContactoGcacchiarelli from './components/ContactoGcacchiarelli'; // 💡 importamos tu vCard
import ContactoKmeza from './components/ContactoKmeza'; // 💡 importamos tu vCard

import '@fortawesome/fontawesome-free/css/all.min.css';

function App() {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

    // Establece el tema inicial
    const initialTheme = mediaQuery.matches ? 'dark' : 'light';
    setTheme(initialTheme);
    document.documentElement.setAttribute('data-theme', initialTheme);

    // Cambia el tema dinámicamente cuando cambia la preferencia del sistema
    const handleChange = (e) => {
      const newTheme = e.matches ? 'dark' : 'light';
      setTheme(newTheme);
      document.documentElement.setAttribute('data-theme', newTheme);
    };

    mediaQuery.addEventListener('change', handleChange);

    // Limpia el evento al desmontar el componente
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return (
    <div className={theme === 'dark' ? 'dark' : ''}>
      <div className="bg-white text-gray-800 transition-colors duration-300 min-h-screen">
        <Router>
          <Routes>
            {/* Landing principal */}
            <Route
              path="/"
              element={
                <>
                  <Navbar />
                  <Hero />
                  <Nosotros />
                  <Valores />
                  <BusinessUnits />
                  <ServiciosElect />
                  <ServiciosIndustria />
                  <LogosSlider />
                  <Contact />
                  <Footer />
                </>
              }
            />
            {/* Ruta para la vCard */}
            <Route path="/contacto-gcacchiarelli" element={<ContactoGcacchiarelli />} />
            <Route path="/contacto-kmeza" element={<ContactoKmeza />} />
          </Routes>
        </Router>
      </div>
    </div>
  );
}

export default App;